import React from "react";
import { Helmet } from "react-helmet";
import { Card } from "antd";

import Header from "../components/visual/header";
import Footer from "../components/visual/footer";
import logo from "../assets/logo.webp";

function Contact() {
  return (
    <>
      <Helmet>
        <title>Contacto | littlecoders.dev. Aprende Python mientras organizas tu día</title>
        <meta name="description" content="Ponte en contacto con littlecoders.dev para cualquier duda sobre nuestras agendas escolares de programación o sugerencias." />
      </Helmet>

      <Header />

      <div 
        style={{ 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center", 
          minHeight: "calc(100vh - 200px)", // Aproximación considerando Header y Footer
          backgroundColor: "#f8f9fa", 
          padding: "60px 20px" 
        }}
      >
        <div style={{ maxWidth: "600px", width: "100%" }}>
          <Card
            className="text-center"
            style={{ 
              borderRadius: "20px", 
              boxShadow: "0 15px 35px rgba(0,0,0,0.05)", 
              border: "none",
              padding: "40px 20px"
            }}
          >
            <a href="/">
              <img
                  src={logo}
                  style={{ width: "200px", marginBottom: "30px" }}
                  alt="littlecoders.dev logo"
              />
            </a>
            
            <h2 style={{ color: "#333", fontWeight: "900", marginBottom: "15px", fontSize: "2.2rem" }}>
              ¡Hola! 👋
            </h2>
            <p style={{ fontSize: "1.1rem", color: "#666", lineHeight: "1.6", marginBottom: "40px" }}>
              ¿Tienes alguna duda sobre nuestras agendas escolares, sugerencias para nuevos ejercicios de Python o necesitas hablar sobre tu centro educativo? Escríbenos.
            </p>

            <a 
              href="mailto:contact@littlecoders.dev?subject=Duda%20sobre%20littlecoders.dev" 
              style={{
                display: "inline-block",
                backgroundColor: "#5B88FA",
                color: "white",
                padding: "15px 30px",
                borderRadius: "30px",
                fontSize: "1.1rem",
                fontWeight: "bold",
                textDecoration: "none",
                boxShadow: "0 4px 15px rgba(91, 136, 250, 0.4)",
                transition: "transform 0.2s"
              }}
              onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
              onMouseOut={(e) => e.target.style.transform = "scale(1)"}
            >
              <i className="fa-solid fa-envelope me-2"></i>
              contact@littlecoders.dev
            </a>
            
            <p style={{ marginTop: "30px", color: "#999", fontSize: "0.9rem" }}>
              Intentamos responder a todas las consultas en un plazo de 24 a 48 horas laborables.
            </p>
          </Card>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Contact;
